import React, { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

import { ChromePicker } from 'react-color';
import type { ColorChangeHandler } from 'react-color';

import CustomIcons from 'assets/icons';

import type { CanvasBackground, CanvasElement } from 'Components/CanvasEditor/types';

interface ColorPickerProps {
  type: 'background' | 'color';
  selectedElement?: CanvasElement | null;
  color: string;
  isSelected?: boolean;
  onChangeColorPicker: ColorChangeHandler;
  onBackgroundChange?: (background: CanvasBackground) => void;
}

export default function ColorPicker({
  type,
  selectedElement,
  color,
  isSelected,
  onChangeColorPicker,
  onBackgroundChange,
}: ColorPickerProps) {
  const ref = useRef<ChromePicker>(null);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClose = () => setDisplayColorPicker(false);

  useEffect(() => {
    if (displayColorPicker) {
      if (ref.current) {
        // @ts-ignore
        ref.current.handleChange(color);
      }
    }
  }, [displayColorPicker]);

  const onClickPickerButton = () => {
    if (!selectedElement && type === 'color') return;
    setDisplayColorPicker(true);
    onBackgroundChange?.({ type: 'color', value: color });
  };

  return (
    <div
      className={classNames('color-field-wrapper', {
        selected: isSelected,
        'color-changer': type === 'color',
      })}
    >
      <button
        aria-label="color-picker"
        className="color-field"
        style={{ background: color }}
        onClick={onClickPickerButton}
      />
      {type === 'background' && (
        <CustomIcons name="color_picker" fontSize={24} className="color-picker-icon" />
      )}
      {displayColorPicker && (
        <div className="popover">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div className="cover" onClick={handleClose} />
          <ChromePicker ref={ref} disableAlpha color={color} onChange={onChangeColorPicker} />
        </div>
      )}
    </div>
  );
}
